import React, {type JSX} from 'react';
import {styled} from '@mui/material/styles';
import {FormLabel as MuiInputLabel, type FormLabelProps} from '@mui/material';

type Props = {
  shrink?: boolean;
} & FormLabelProps;

function Label({shrink: _shrink, ...props}: Readonly<Props>): JSX.Element {
  return <MuiInputLabel {...props} />;
}

export const InputLabel = styled(Label)<Props>(({shrink}) => ({
  ...(shrink && {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  }),
}));
